export const UPDATE_DIR_DATA='DIRPAGE/UPDATE_DIR_DATA';

export const CITY_DIRECTORY_PAGE = "CITY_DIRECTORY_PAGE";
export const ROUTES_DIRECTORY_PAGE = "ROUTES_DIRECTORY_PAGE"
export const OPERATOR_DIRECTORY_PAGE = "OPERATOR_DIRECTORY_PAGE"

export const CITY_DIRECTORY_URL = "/bus/city-buses/";
export const ROUTES_DIRECTORY_URL = "/bus/bus-routes/"
export const OPERATOR_DIRECTORY_URL = "/bus/bus-operators/"
